// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { sendVisitedChallenge } from '../../apis/challenge';
import { RootAction, actionCreatorsList } from '../rootActionCreator';
const { sendVisitedChallengeActions } = actionCreatorsList;

const outputActions = {
  success: sendVisitedChallengeActions.success,
  failure: sendVisitedChallengeActions.failure
};

type RequestActionTypes = ActionType<
  typeof sendVisitedChallengeActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const sendVisitedChallengeEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(sendVisitedChallengeActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return sendVisitedChallenge(id)
        .then(response => {
          return sendVisitedChallengeActions.success({});
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return sendVisitedChallengeActions.failure({ error });
        });
    })
  );
};

export { sendVisitedChallengeEpic as default};
